import {
  Briefcase,
  Search,
  Settings,
  SquarePlus,
  type LucideIcon,
} from "lucide-react"
import {
  ADMIN_OPS_ROUTES_GROUP,
  GENERAL_ROUTES_GROUP,
} from "@hooks/useHasPermissions"

interface NavSubItem {
  title: string
  href: string
}

interface NavItemBase {
  title: string
  icon: LucideIcon
  allowedRoles?: readonly string[]
}

interface NavLinkItem extends NavItemBase {
  href: string
  items?: never
}

// Groups only hold sub-items, there is no page at the group level
export interface NavGroupItem extends NavItemBase {
  href?: never
  items: NavSubItem[]
}

export type NavItem = NavLinkItem | NavGroupItem

const NAV_ITEMS: NavItem[] = [
  {
    title: "Member Search",
    href: "/search",
    icon: Search,
    allowedRoles: GENERAL_ROUTES_GROUP,
  },
  {
    title: "Create Prospect",
    href: "/prospect/create",
    icon: SquarePlus,
    allowedRoles: GENERAL_ROUTES_GROUP,
  },
  {
    title: "Cases",
    href: "/cases",
    icon: Briefcase,
    allowedRoles: GENERAL_ROUTES_GROUP,
  },
  {
    title: "Account Operations",
    icon: Settings,
    allowedRoles: ADMIN_OPS_ROUTES_GROUP,
    items: [
      { title: "Failed Orders", href: "/ops/orders/failed" },
      { title: "Mass Notate", href: "/ops/mass_notate" },
      { title: "Bulk Add Traits", href: "/ops/bulk_add_traits" },
      { title: "Aged Pending Accounts", href: "/ops/aged_accounts" },
      { title: "Rewards", href: "/ops/rewards" },
    ],
  },
]

export const getNavItems = (userRoles: { name: string }[]) => {
  const roleNames = userRoles.map((role) => role.name)

  return NAV_ITEMS.filter(
    ({ allowedRoles }) =>
      !allowedRoles || allowedRoles.some((role) => roleNames.includes(role)),
  )
}
